import { onDomReady } from "./observer.js";

class GiveGift {
    constructor() {
        this.options = {
            fileTag: '[data-gift-file]',
            nameTag: '[data-gift-name]',
            costTag: '[data-gift-cost]',
            targetTag: '[data-gift-target]',
            sendTag: '[data-gift-send1text]',
            buyTag: '[data-gift-buy-tokens]',
            nowayTag: '[data-gift-noway]',
            receiveTag: '[data-gift-receive]',
        };

        this.elements = {
            fileElm: document.querySelectorAll(this.options.fileTag),
            targetElm: document.querySelector(this.options.targetTag),
            sendElm: document.querySelector(this.options.sendTag),
            buyElm: document.querySelector(this.options.buyTag),
            nowayElm: document.querySelector(this.options.nowayTag),
            receiveElm: document.querySelector(this.options.receiveTag),
        };

        this.init();
    }

    init() {
        if (this.elements.fileElm.length > 0 && this.elements.targetElm) {
            this.elements.fileElm.forEach((fileItem) => {
                fileItem.addEventListener('click', (event) => {

                    if (!fileItem.dataset.giftFile || !fileItem.dataset.giftCost) {
                        console.warn('Missing dataset attributes on fileItem:', fileItem);
                        return;
                    }

                    const fileVal = fileItem.dataset.giftFile;
                    const nameVal = fileItem.dataset.giftName;
                    const idVal = fileItem.dataset.giftId;
                    const costVal = parseInt(fileItem.dataset.giftCost, 10);
                    const targetVar = this.elements.targetElm;

                    if (isNaN(costVal)) {
                        console.warn('Invalid giftCost value:', fileItem.dataset.giftCost);
                        return;
                    }

                    targetVar.src = targetVar.dataset.giftTarget + fileVal;
                    targetVar.alt = nameVal;
                    targetVar.title = nameVal;

                    if (this.elements.sendElm && this.elements.buyElm) {
                        const sendVar = this.elements.sendElm;
                        const buyVar = this.elements.buyElm;
                        sendVar.innerHTML = `${sendVar.dataset.giftSend1text} ${costVal} ${sendVar.dataset.giftSend2text}`;
                        sendVar.dataset.giftBuyid = idVal;

                        const balanceVar = parseInt(sendVar.dataset.giftTokens, 10);
                        if (isNaN(balanceVar) || balanceVar < costVal) {
                            sendVar.classList.add('hidden');
                            buyVar.classList.remove('hidden');
                            if (this.elements.nowayElm) {
                                this.elements.nowayElm.classList.remove('hidden');
                            }
                            if (this.elements.receiveElm) {
                                this.elements.receiveElm.classList.add('hidden');
                            }
                        } else {
                            sendVar.classList.remove('hidden');
                            buyVar.classList.add('hidden');
                            if (this.elements.nowayElm) {
                                this.elements.nowayElm.classList.add('hidden');
                            }
                            if (this.elements.receiveElm) {
                                this.elements.receiveElm.classList.remove('hidden');
                            }
                        }
                    }
                });
            });
        }
    }
}

onDomReady(() => {
    const header = new GiveGift();
}, false);